export default __webpack_public_path__ + "static/media/new-setting.f3280ade.svg";